import { FC } from 'react';
import cn from 'classnames';
import { useTrans } from 'base/utils/i18n';
import { Iconfont } from '@base/lib/Iconfont';
import { sum } from 'base/utils/arr';
import { LoopRender } from '@base/snippets/LoopRender';
import { Image } from '@base/lib/ThemeImage';
import { IconArrow } from '@base/icon';
import { IGiftItem } from 'base/interfaces/product';

type IProps = {
    className?: string;
    gifts: IGiftItem[];
    openPopup: () => void;
};

export const GiftsTrigger: FC<IProps> = props => {
    const { className, gifts, openPopup } = props;
    const { t } = useTrans();

    return gifts.length === 0 ? null : (
        <>
            <div
                className={cn(className, 'flex flex-middle pointer text-nowrap')}
                onClick={openPopup}
            >
                <Iconfont className={'icon-gift'}/>

                <div className={'mr-2'}>{t('web_common_free_gift')}</div>

                <div className="g-items overflow flex-1 flex flex-middle flex-right flex-wrap">
                    <div className={'g-items-label'}>
                        {t('web_common_num_items', { num: sum(gifts.map(item => item.num)) })}
                    </div>

                    <LoopRender
                        tag={false}
                        list={gifts}
                        render={item => (
                            <Image
                                className={'g-item'}
                                src={item.pic}
                                width={24}
                                fixed
                                background={false}
                            />
                        )}
                    />
                </div>

                <IconArrow className={'g-arrow'} direction={'right'}/>
            </div>
        </>
    )
};
